<div class="card-grid" role="list">
    <app-reporting-card *ngFor="let report of standardReports" [report]="report">
        <ui-badge *ngIf="report.disabled">
            {{ 'reporting.reports.needModule' | translate: { module: report.requiredModule } }}</ui-badge
        >
    </app-reporting-card>
</div>
